<template>
  <div class="client-form p-4 space-y-8">
    <div class="card-title">Client Data: {{client_id}}</div>
    <div class="card-subtitle">Client name: {{client_name}}</div>
    <hr>
    <div v-if="uploading">Uploading ...</div>
    <div v-else>
      <div class="form-group col-md-12">

        <div class="col-md-12">
          <label for="name" class="col-md-4">
            Name
          </label>
          <div class="col-md-8">
            <i v-if="!form.name" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="name"
                id="name"
                v-model="form.name"
            />
            <span class="help-block">The Client's name.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="createdAt" class="col-md-4">
            The date the Client was created.
          </label>
          <div class="col-md-8">
            <i v-if="!form.createdAt" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="createdAt"
                id="createdAt"
                v-model="form.createdAt"
            />
            <span class="help-block">The date the Client was created.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="campaign.type" class="col-md-4">
            Campaign type
          </label>
          <div class="col-md-8">
            <i v-if="!form.campaign.type" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="type"
                id="campaign.type"
                v-model="form.campaign.type"
            />

            <span class="help-block">The Type of the campaign</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="campaign.source" class="col-md-4">
            Campaign source
          </label>
          <div class="col-md-8">
            <i v-if="!form.campaign.source" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="campaign.source"
                id="campaign.source"
                v-model="form.campaign.source"
            />
            <span class="help-block">The Source of the campaign.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="campaign.source" class="col-md-4">
            A Reference to associate with the campaign.
          </label>
          <div class="col-md-8">
            <i v-if="!form.campaign.reference" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="campaign.reference"
                id="campaign.reference"
                v-model="form.campaign.reference"
            />
            <span class="help-block">The Client's name.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="category" class="col-md-4">
            Category
          </label>
          <div class="col-md-8">
            <i v-if="!form.category" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="category"
                id="category"
                v-model="form.category"
            />
            <span class="help-block">The category of Client to which the Client belongs.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="migrationReference" class="col-md-4">
            Migration Reference
          </label>
          <div class="col-md-8">
            <i v-if="!form.migrationReference" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="migrationReference"
                id="migrationReference"
                v-model="form.migrationReference"
            />
            <span class="help-block">The Client migration reference.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="externalReference" class="col-md-4">
            External Reference
          </label>
          <div class="col-md-8">
            <i v-if="!form.externalReference" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="externalReference"
                id="externalReference"
                v-model="form.externalReference"
            />
            <span class="help-block">An external reference for the Client.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="secondaryReference" class="col-md-4">
            Secondary Reference
          </label>
          <div class="col-md-8">
            <i v-if="!form.secondaryReference" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="secondaryReference"
                id="secondaryReference"
                v-model="form.secondaryReference"
            />
            <span class="help-block">An secondary external reference for the Client</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="originalAdviser.id" class="col-md-4">
            Original Adviser ID
          </label>
          <div class="col-md-8">
            <i v-if="!form.originalAdviser.id" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="originalAdviser.id"
                id="originalAdviser.id"
                v-model="form.originalAdviser.id"
            />
            <span class="help-block">The unique identifier for the Adviser (original)</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="currentAdviser.id" class="col-md-4">
            Current Adviser ID
          </label>
          <div class="col-md-8">
            <i v-if="!form.currentAdviser.id" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="currentAdviser.id"
                id="currentAdviser.id"
                v-model="form.currentAdviser.id"
            />
            <span class="help-block">The unique identifier for the Adviser (current)</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="partyType" class="col-md-4">
            Party Type
          </label>
          <div class="col-md-8">
            <i v-if="!form.partyType" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="partyType"
                id="partyType"
                v-model="form.partyType"
            />
            <span class="help-block">The type of Client, either Person, Trust or Corporate.</span>
          </div>
        </div>

        <div class="col-md-12">
          <p><label>Person</label></p>
          <hr>
        </div>

        <div class="col-md-12">
          <label for="person.salutation" class="col-md-4">
            Person Salutation
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.salutation" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.salutation"
                id="person.salutation"
                v-model="form.person.salutation"
            />
            <span class="help-block">The Person's preferred salutation if known</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.title" class="col-md-4">
            Person title
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.title" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.title"
                id="person.title"
                v-model="form.person.title"
            />
            <span class="help-block">The Person's title</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.firstName" class="col-md-4">
            Person First Name
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.firstName" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.firstName"
                id="person.firstName"
                v-model="form.person.firstName"
            />
            <span class="help-block">The Person's first name.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.middleName" class="col-md-4">
            Person Middle Name
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.middleName" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.middleName"
                id="person.middleName"
                v-model="form.person.middleName"
            />
            <span class="help-block">The Person's middle name if they have one</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.lastName" class="col-md-4">
            Person Last Name
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.lastName" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.lastName"
                id="person.lastName"
                v-model="form.person.lastName"
            />
            <span class="help-block">The Person's last name.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.dateOfBirth" class="col-md-4">
            Person Date Of Birth
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.dateOfBirth" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.dateOfBirth"
                id="person.dateOfBirth"
                v-model="form.person.dateOfBirth"
            />
            <span class="help-block">The Person's date of birth.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.gender" class="col-md-4">
            Person Gender
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.gender" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.gender"
                id="person.gender"
                v-model="form.person.gender"
            />
            <span class="help-block">The Person's gender.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.maidenName" class="col-md-4">
            Person Maiden Name
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.maidenName" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.maidenName"
                id="person.maidenName"
                v-model="form.person.maidenName"
            />
            <span class="help-block">The Person's maiden name.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.niNumber" class="col-md-4">
            Person Ni Number
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.niNumber" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.niNumber"
                id="person.niNumber"
                v-model="form.person.niNumber"
            />
            <span class="help-block">The Person's National Insurance number (in UK), Social Security Number (in US) or local equivalent.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.maritalStatus" class="col-md-4">
            Person Marital Status
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.maritalStatus" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.maritalStatus"
                id="person.maritalStatus"
                v-model="form.person.maritalStatus"
            />
            <span class="help-block">The Person's marital status.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.maritalStatusSince" class="col-md-4">
            Person Marital Status Since
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.maritalStatusSince" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.maritalStatusSince"
                id="person.maritalStatusSince"
                v-model="form.person.maritalStatusSince"
            />
            <span class="help-block">The date the Person was married if appropriate.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.nationality" class="col-md-4">
            Person Nationality
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.nationality" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.nationality"
                id="person.nationality"
                v-model="form.person.nationality"
            />
            <span class="help-block">This property has been depricated and will be removed in future. Please use NationalityCountry instead.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.nationalityCountry.isoCode" class="col-md-4">
            Person Nationality Country ISO Code
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.nationalityCountry.isoCode" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.nationalityCountry.isoCode"
                id="person.nationalityCountry.isoCode"
                v-model="form.person.nationalityCountry.isoCode"
            />
            <span class="help-block">The ISO country code (ISO 3166-1 alpha-3) for the country. If this IsoCode is provided during creation or update of the Client or Lead, the Nationality property on the Person will be set according to the value of this IsoCode property.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.isDeceased" class="col-md-4">
            Person Is Deceased
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.isDeceased" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.isDeceased"
                id="person.isDeceased"
                v-model="form.person.isDeceased"
            />
            <span class="help-block">Flag indicating whether the Person has died. If set to true the deceasedOn date must also be set.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.deceasedOn" class="col-md-4">
            Person Deceased On
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.deceasedOn" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.deceasedOn"
                id="person.deceasedOn"
                v-model="form.person.deceasedOn"
            />
            <span class="help-block">The date of the Person's death. This must be set if isDeceased is true.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.territorialProfile.ukResident" class="col-md-4">
            Person Territorial Profile UK Resident
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.territorialProfile.ukResident" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.territorialProfile.ukResident"
                id="person.territorialProfile.ukResident"
                v-model="form.person.territorialProfile.ukResident"
            />
            <span class="help-block">Flag indicating if the person is a resident of the UK or not?</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.territorialProfile.countryOfBirth" class="col-md-4">
            Person Territorial Profile Country Of Birth
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.territorialProfile.countryOfBirth" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.territorialProfile.countryOfBirth"
                id="person.territorialProfile.countryOfBirth"
                v-model="form.person.territorialProfile.countryOfBirth"
            />
            <span class="help-block">The person's country of birth. Note: This property has been depricated and will be removed in future. Please use CountryOfOrigin instead.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.territorialProfile.ukDomicile" class="col-md-4">
            Person Territorial Profile UK Domicile
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.territorialProfile.ukDomicile" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.territorialProfile.ukDomicile"
                id="person.territorialProfile.ukDomicile"
                v-model="form.person.territorialProfile.ukDomicile"
            />
            <span class="help-block">Flag indicating if the person is domiciled in the UK or not? Note: This property has been depricated and will be removed in future. Please use CountryOfDomicile instead. If provided the CountryOfDomicile property will be used to set the the value of the UkDomicile property.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.territorialProfile.expatriate" class="col-md-4">
            Person Territorial Profile Expatriate
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.territorialProfile.expatriate" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.territorialProfile.expatriate"
                id="person.territorialProfile.expatriate"
                v-model="form.person.territorialProfile.expatriate"
            />
            <span class="help-block">Flag indicating if the person an expatriate or not?</span>
          </div>
        </div>


        <div class="col-md-12">
          <label for="person.territorialProfile.countryOfResidence.code" class="col-md-4">
            Person Territorial Profile Country Of Residence Code
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.territorialProfile.countryOfResidence.code" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.territorialProfile.countryOfResidence.code"
                id="person.territorialProfile.countryOfResidence.code"
                v-model="form.person.territorialProfile.countryOfResidence.code"
            />
            <span class="help-block"> The ISO country code (ISO 3166-1 alpha-2) for the country. (countryOfResidence)</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.territorialProfile.countryOfDomicile.code" class="col-md-4">
            Person Territorial Profile Country Of Domicile Code
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.territorialProfile.countryOfDomicile.code" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.territorialProfile.countryOfDomicile.code"
                id="person.territorialProfile.countryOfDomicile.code"
                v-model="form.person.territorialProfile.countryOfDomicile.code"
            />
            <span class="help-block">The ISO country code (ISO 3166-1 alpha-2) for the country. (countryOfDomicile)</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.territorialProfile.countryOfOrigin.code" class="col-md-4">
            Person Territorial Profile Country Of Origin Code
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.territorialProfile.countryOfOrigin.code" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.territorialProfile.countryOfOrigin.code"
                id="person.territorialProfile.countryOfOrigin.code"
                v-model="form.person.territorialProfile.countryOfOrigin.code"
            />
            <span class="help-block">The ISO country code (ISO 3166-1 alpha-2) for the country. (countryOfOrigin)</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.territorialProfile.countryOfOrigin.name" class="col-md-4">
            Person Territorial Profile Country Of Origin Name
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.territorialProfile.countryOfOrigin.name" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.territorialProfile.countryOfOrigin.name"
                id="person.territorialProfile.countryOfOrigin.name"
                v-model="form.person.territorialProfile.countryOfOrigin.name"
            />
            <span class="help-block">The countries name. This is devived from the Code. (countryOfOrigin)</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.territorialProfile.placeOfBirth" class="col-md-4">
            Person Territorial Profile Place Of Birth
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.territorialProfile.placeOfBirth" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.territorialProfile.placeOfBirth"
                id="person.territorialProfile.placeOfBirth"
                v-model="form.person.territorialProfile.placeOfBirth"
            />
            <span class="help-block">Place of birth of the person.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.territorialProfile.countriesOfCitizenship.code" class="col-md-4">
            Person Territorial Profile Countries Of Citizenship Code
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.territorialProfile.countriesOfCitizenship.code" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.territorialProfile.countriesOfCitizenship.code"
                id="person.territorialProfile.countriesOfCitizenship.code"
                v-model="form.person.territorialProfile.countriesOfCitizenship.code"
            />
            <span class="help-block">Countries where the person has citizenship. The ISO country code (ISO 3166-1 alpha-2) for the country.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.healthProfile.isSmoker" class="col-md-4">
            Person Health Profile Is Smoker
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.healthProfile.isSmoker" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.healthProfile.isSmoker"
                id="person.healthProfile.isSmoker"
                v-model="form.person.healthProfile.isSmoker"
            />
            <span class="help-block">Flag indicating if the person is a smoker or not?</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.healthProfile.smokedInLast12Months" class="col-md-4">
            Person Health Profile Smoked In Last 12 Months
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.healthProfile.smokedInLast12Months" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.healthProfile.smokedInLast12Months"
                id="person.healthProfile.smokedInLast12Months"
                v-model="form.person.healthProfile.smokedInLast12Months"
            />
            <span class="help-block">Flag indicating if the person has smoked in last 12 months ot not?</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.healthProfile.everSmoked" class="col-md-4">
            Person Health Profile Ever Smoked
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.healthProfile.everSmoked" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.healthProfile.everSmoked"
                id="person.healthProfile.everSmoked"
                v-model="form.person.healthProfile.everSmoked"
            />
            <span class="help-block">Flag indicating if the person has Ever Smoked or not?</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.healthProfile.hasVapedorUsedEcigarettesLast1Year" class="col-md-4">
            Person Health Profile Has Vapedor Used Ecigarettes Last 1 Year
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.healthProfile.hasVapedorUsedEcigarettesLast1Year" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.healthProfile.hasVapedorUsedEcigarettesLast1Year"
                id="person.healthProfile.hasVapedorUsedEcigarettesLast1Year"
                v-model="form.person.healthProfile.hasVapedorUsedEcigarettesLast1Year"
            />
            <span class="help-block">Flag indicating if the person has Vaped or Used Ecigarettes Last 1 Year?</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.healthProfile.haveUsedNicotineReplacementProductsLast1Year" class="col-md-4">
            Person Health Profile Have Used Nicotine Replacement Products Last 1 Year
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.healthProfile.haveUsedNicotineReplacementProductsLast1Year" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.healthProfile.haveUsedNicotineReplacementProductsLast1Year"
                id="person.healthProfile.haveUsedNicotineReplacementProductsLast1Year"
                v-model="form.person.healthProfile.haveUsedNicotineReplacementProductsLast1Year"
            />
            <span class="help-block">Flag indicating if the person has Used Nicotine Replacement Products Last 1 Year?</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.healthProfile.inGoodHealth" class="col-md-4">
            Person Health Profile In Good Health
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.healthProfile.inGoodHealth" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.healthProfile.inGoodHealth"
                id="person.healthProfile.inGoodHealth"
                v-model="form.person.healthProfile.inGoodHealth"
            />
            <span class="help-block">Flag indicating if the person is considered to be in good health or not?</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.healthProfile.isSmoker" class="col-md-4">
            Person Health Profile Is Smoker
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.healthProfile.isSmoker" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.healthProfile.isSmoker"
                id="person.healthProfile.isSmoker"
                v-model="form.person.healthProfile.isSmoker"
            />
            <span class="help-block">Flag indicating if the person is a smoker or not?</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.hasWill" class="col-md-4">
            Person Has Will
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.hasWill" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.hasWill"
                id="person.hasWill"
                v-model="form.person.hasWill"
            />
            <span class="help-block">Flag indicatiing whether the Person has a will or not.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.isWillUptoDate" class="col-md-4">
            Person Is Will Upto Date
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.isWillUptoDate" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.isWillUptoDate"
                id="person.isWillUptoDate"
                v-model="form.person.isWillUptoDate"
            />
            <span class="help-block">Flag indicatiing whether the Person's will is upto date or not.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.isPowerOfAttorneyGranted" class="col-md-4">
            Person Is Power Of Attorney Granted
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.isPowerOfAttorneyGranted" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.isPowerOfAttorneyGranted"
                id="person.isPowerOfAttorneyGranted"
                v-model="form.person.isPowerOfAttorneyGranted"
            />
            <span class="help-block">Flag indicating if the Person has assigned someone to act on their behalf in legal or financial matters.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="person.nationalClientIdentifier" class="col-md-4">
            Person National Client Identifier
          </label>
          <div class="col-md-8">
            <i v-if="!form.person.nationalClientIdentifier" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="person.nationalClientIdentifier"
                id="person.nationalClientIdentifier"
                v-model="form.person.nationalClientIdentifier"
            />
            <span class="help-block">The National Client Identifier associated with the Person. This is a unique country specific client identifier eg. National Insurance number for UK.</span>
          </div>
        </div>

        <div class="col-md-12">
        <hr>
          <p><label>Corporate</label></p>
        </div>

        <div class="col-md-12">
          <label for="corporate.name" class="col-md-4">
            Corporate Name
          </label>
          <div class="col-md-8">
            <i v-if="!form.corporate.name" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="corporate.name"
                id="corporate.name"
                v-model="form.corporate.name"
            />
            <span class="help-block">The company's name.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="corporate.type" class="col-md-4">
            Corporate Type
          </label>
          <div class="col-md-8">
            <i v-if="!form.corporate.type" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="corporate.type"
                id="corporate.type"
                v-model="form.corporate.type"
            />
            <span class="help-block">The type of a company.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="corporate.businessType" class="col-md-4">
            Corporate Business Type
          </label>
          <div class="col-md-8">
            <i v-if="!form.corporate.businessType" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="corporate.businessType"
                id="corporate.businessType"
                v-model="form.corporate.businessType"
            />
            <span class="help-block">The company's business type.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="corporate.companyRegistrationNumber" class="col-md-4">
            Corporate Company Registration Number
          </label>
          <div class="col-md-8">
            <i v-if="!form.corporate.companyRegistrationNumber" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="corporate.companyRegistrationNumber"
                id="corporate.companyRegistrationNumber"
                v-model="form.corporate.companyRegistrationNumber"
            />
            <span class="help-block">The company's registration number.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="corporate.establishedOrIncorporatedOn" class="col-md-4">
            Corporate Established Or Incorporated On
          </label>
          <div class="col-md-8">
            <i v-if="!form.corporate.establishedOrIncorporatedOn" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="corporate.establishedOrIncorporatedOn"
                id="corporate.establishedOrIncorporatedOn"
                v-model="form.corporate.establishedOrIncorporatedOn"
            />
            <span class="help-block">The date the company was established.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="corporate.isVatRegistered" class="col-md-4">
            Corporate Is Vat Registered
          </label>
          <div class="col-md-8">
            <i v-if="!form.corporate.isVatRegistered" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="corporate.isVatRegistered"
                id="corporate.isVatRegistered"
                v-model="form.corporate.isVatRegistered"
            />
            <span class="help-block">Flag Indicating if the company is registered for VAT/GST.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="corporate.vatRegistrationNumber" class="col-md-4">
            Corporate Vat Registration Number
          </label>
          <div class="col-md-8">
            <i v-if="!form.corporate.vatRegistrationNumber" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="corporate.vatRegistrationNumber"
                id="corporate.vatRegistrationNumber"
                v-model="form.corporate.vatRegistrationNumber"
            />
            <span class="help-block">The Company's VAT/GST registration number.</span>
          </div>
        </div>


        <div class="col-md-12">
          <label for="corporate.legalEntity.identifier" class="col-md-4">
            Corporate Legal Entity Identifier
          </label>
          <div class="col-md-8">
            <i v-if="!form.corporate.legalEntity.identifier" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="corporate.legalEntity.identifier"
                id="corporate.legalEntity.identifier"
                v-model="form.corporate.legalEntity.identifier"
            />
            <span class="help-block">Legal entity identifier.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="corporate.legalEntity.expiresOn" class="col-md-4">
            Corporate Legal Entity Expires On
          </label>
          <div class="col-md-8">
            <i v-if="!form.corporate.legalEntity.expiresOn" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="corporate.legalEntity.expiresOn"
                id="corporate.legalEntity.expiresOn"
                v-model="form.corporate.legalEntity.expiresOn"
            />
            <span class="help-block">Expiry date of legal identifier</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="corporate.businessRegistrationNumber" class="col-md-4">
            Corporate Business Registration Number
          </label>
          <div class="col-md-8">
            <i v-if="!form.corporate.businessRegistrationNumber" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="corporate.businessRegistrationNumber"
                id="corporate.businessRegistrationNumber"
                v-model="form.corporate.businessRegistrationNumber"
            />
            <span class="help-block">Business registration number.</span>
          </div>
        </div>

        <div class="col-md-12">
        <hr>
          <p><label>Trust</label></p>
        </div>

        <div class="col-md-12">
          <label for="trust.name" class="col-md-4">
            Trust Name
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.name" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.name"
                id="trust.name"
                v-model="form.trust.name"
            />
            <span class="help-block">The trust's name.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="trust.type" class="col-md-4">
            Trust Type
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.type" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.type"
                id="trust.type"
                v-model="form.trust.type"
            />
            <span class="help-block">The type of a trust.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="trust.establishedOrIncorporatedOn" class="col-md-4">
            Trust Established Or Incorporated On
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.establishedOrIncorporatedOn" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.establishedOrIncorporatedOn"
                id="trust.establishedOrIncorporatedOn"
                v-model="form.trust.establishedOrIncorporatedOn"
            />
            <span class="help-block">The date of incorporation for the Trust</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="trust.registrationNumber" class="col-md-4">
            Trust Registration Number
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.registrationNumber" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.registrationNumber"
                id="trust.registrationNumber"
                v-model="form.trust.registrationNumber"
            />
            <span class="help-block">The Trust's registration number.</span>
          </div>
        </div>


        <div class="col-md-12">
          <label for="trust.registeredOn" class="col-md-4">
            Trust Registered On
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.registeredOn" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.registeredOn"
                id="trust.registeredOn"
                v-model="form.trust.registeredOn"
            />
            <span class="help-block">The date the trust was registered.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="trust.legalEntity.identifier" class="col-md-4">
            Trust Legal Entity Identifier
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.legalEntity.identifier" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.legalEntity.identifier"
                id="trust.legalEntity.identifier"
                v-model="form.trust.legalEntity.identifier"
            />
            <span class="help-block">Legal entity identifier.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="trust.legalEntity.expiresOn" class="col-md-4">
            Trust Legal Entity Expires On
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.legalEntity.expiresOn" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.legalEntity.expiresOn"
                id="trust.legalEntity.expiresOn"
                v-model="form.trust.legalEntity.expiresOn"
            />
            <span class="help-block">Expiry date of legal identifier.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="trust.instrument" class="col-md-4">
            Trust Instrument
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.instrument" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.instrument"
                id="trust.instrument"
                v-model="form.trust.instrument"
            />
            <span class="help-block">The instrument used for setting up the Trust. This may be one of TrustDeed, Will or Intestacy.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="trust.businessRegistrationNumber" class="col-md-4">
            Trust Business Registration Number
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.businessRegistrationNumber" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.businessRegistrationNumber"
                id="trust.businessRegistrationNumber"
                v-model="form.trust.businessRegistrationNumber"
            />
            <span class="help-block">Business registration number.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="trust.natureOfTrust" class="col-md-4">
            Trust Nature Of Trust
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.natureOfTrust" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.natureOfTrust"
                id="trust.natureOfTrust"
                v-model="form.trust.natureOfTrust"
            />
            <span class="help-block">A short description of the Trust and its objectives.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="trust.vatRegistrationNumber" class="col-md-4">
            Trust Vat Registration Number
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.vatRegistrationNumber" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.vatRegistrationNumber"
                id="trust.vatRegistrationNumber"
                v-model="form.trust.vatRegistrationNumber"
            />
            <span class="help-block">The Trust's VAT/GST registration number.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="trust.residenceCountry.id" class="col-md-4">
            Trust Residence Country Id
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.residenceCountry.id" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.residenceCountry.id"
                id="trust.residenceCountry.id"
                v-model="form.trust.residenceCountry.id"
            />
            <span class="help-block">The unique identifier for the country.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="trust.establishmentCountry.id" class="col-md-4">
            Trust Establishment Country Id
          </label>
          <div class="col-md-8">
            <i v-if="!form.trust.establishmentCountry.id" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="trust.establishmentCountry.id"
                id="trust.establishmentCountry.id"
                v-model="form.trust.establishmentCountry.id"
            />
            <span class="help-block">The unique identifier for the country.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="isHeadOfFamilyGroup" class="col-md-4">
            Is Head Of Family Group
          </label>
          <div class="col-md-8">
            <i v-if="!form.isHeadOfFamilyGroup" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="isHeadOfFamilyGroup"
                id="isHeadOfFamilyGroup"
                v-model="form.isHeadOfFamilyGroup"
            />
            <span class="help-block">Flag indicating whether or not the Client is the head of a family group.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="servicingAdministrator.id" class="col-md-4">
            Servicing Administrator Id
          </label>
          <div class="col-md-8">
            <i v-if="!form.servicingAdministrator.id" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="servicingAdministrator.id"
                id="servicingAdministrator.id"
                v-model="form.servicingAdministrator.id"
            />
            <span class="help-block">The unique identifier for the user.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="paraplanner.id" class="col-md-4">
            Paraplanner Id
          </label>
          <div class="col-md-8">
            <i v-if="!form.paraplanner.id" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="paraplanner.id"
                id="paraplanner.id"
                v-model="form.paraplanner.id"
            />
            <span class="help-block">The unique identifier for the user.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="tags" class="col-md-4">
            Tags
          </label>
          <div class="col-md-8">
            <i v-if="!form.tags" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="tags"
                id="tags"
                v-model="form.tags"
            />
            <span class="help-block">A list of tags associated with the Client. The list can contain up to 30 tags. Each tag has a maximum length of 100 charecters and may not contain spaces.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="taxReferenceNumber" class="col-md-4">
            Tax Reference Number
          </label>
          <div class="col-md-8">
            <i v-if="!form.taxReferenceNumber" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="taxReferenceNumber"
                id="taxReferenceNumber"
                v-model="form.taxReferenceNumber"
            />
            <span class="help-block">The Client's tax reference number. The value returned will be obfuscated unless the api is called with the scope of the request set to client_identification_data.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="user.id" class="col-md-4">
            User Id
          </label>
          <div class="col-md-8">
            <i v-if="!form.user.id" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="user.id"
                id="user.id"
                v-model="form.user.id"
            />
            <span class="help-block">The unique identifier for the user.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="serviceStatus.name" class="col-md-4">
            Service Status Name
          </label>
          <div class="col-md-8">
            <i v-if="!form.serviceStatus.name" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="serviceStatus.name"
                id="serviceStatus.name"
                v-model="form.serviceStatus.name"
            />
            <span class="help-block">Service Status Name</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="serviceStatus.startedOn" class="col-md-4">
            Service Status Started On
          </label>
          <div class="col-md-8">
            <i v-if="!form.serviceStatus.startedOn" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="serviceStatus.startedOn"
                id="serviceStatus.startedOn"
                v-model="form.serviceStatus.startedOn"
            />
            <span class="help-block">Service Status Started On</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="clientSegment.name" class="col-md-4">
            Client Segment Name
          </label>
          <div class="col-md-8">
            <i v-if="!form.clientSegment.name" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="clientSegment.name"
                id="clientSegment.name"
                v-model="form.clientSegment.name"
            />
            <span class="help-block">Client Segment Name</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="clientSegment.startedOn" class="col-md-4">
            Client Segment Started On
          </label>
          <div class="col-md-8">
            <i v-if="!form.clientSegment.startedOn" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="clientSegment.startedOn"
                id="clientSegment.startedOn"
                v-model="form.clientSegment.startedOn"
            />
            <span class="help-block">Client Segment Started On</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="group.id" class="col-md-4">
            Group Id
          </label>
          <div class="col-md-8">
            <i v-if="!form.group.id" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="group.id"
                id="group.id"
                v-model="form.group.id"
            />
            <span class="help-block">The group identifier.</span>
          </div>
        </div>

        <div class="col-md-12">
          <label for="household.name" class="col-md-4">
            Household Name
          </label>
          <div class="col-md-8">
            <i v-if="!form.household.name" class="fa fa-exclamation-triangle text-warning missing-data-icon"></i>
            <input
                type="text"
                class="form-control"
                name="household.name"
                id="household.name"
                v-model="form.household.name"
            />
            <span class="help-block">The name of the household.</span>
          </div>
        </div>


      <div class="form-group">
        <div class="col-md-12">
          <button class="answer-button" v-on:click="sendNewData('update-missing-data')">
            <span class="update-answer">UPDATE</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "IntellifloOfficeClientForm",
  props: ["client_id", "client_name"],
  data() {
    return {
      uploading: true,
      genderOptions: {
        'Unspecified': 'Unspecified',
        'Male': 'Male',
        'Female': 'Male'
      },
      categoryOptions: {
        'Retail': 'Retail',
        'Professional': 'Professional',
        'EligibleCounterparty': 'EligibleCounterparty',
        'Customer': 'Customer',
        'LargeBusinessCustomer': 'LargeBusinessCustomer',
        'Consumer': 'Consumer',
        'CommercialCustomer': 'CommercialCustomer',
      },
      partyTypeOptions: {
        'Person': 'Person',
        'Trust': 'Trust',
        'Corporate': 'Corporate',
      },
      isSmokerOptions: {
        'Unknown': 'Unknown',
        'Yes': 'Yes',
        'No': 'No',
      },
      form: {
        name: '',
        createdAt: '',
        campaign: { type: '', source: '', reference: '' },
        category: '',
        migrationReference: '',
        externalReference: '',
        secondaryReference: '',
        originalAdviser: { id: 0 },
        currentAdviser: { id: 0 },
        partyType: 'Person',
        person: {
          salutation: '',
          title: '',
          firstName: '',
          middleName: '',
          lastName: '',
          dateOfBirth: '',
          gender: 'Unspecified',
          maidenName: '',
          niNumber: '',
          maritalStatus: '',
          maritalStatusSince: '',
          nationality: '',
          nationalityCountry: {
            isoCode: ''
          },
          isDeceased: false,
          deceasedOn: '',
          territorialProfile: {
            ukResident: false,
            countryOfBirth: '',
            ukDomicile: false,
            expatriate: false,
            countryOfResidence: {
              code: '',
            },
            countryOfDomicile: {
              code: '',
            },
            countryOfOrigin: {
              code: '',
              name: '',
            },
            placeOfBirth: '',
            countriesOfCitizenship: [
              {
                code: ''
              }
            ]
          },
          healthProfile: {
            isSmoker: 'Unknown',
            smokedInLast12Months: false,
            everSmoked: false,
            hasVapedorUsedEcigarettesLast1Year: false,
            haveUsedNicotineReplacementProductsLast1Year: false,
            inGoodHealth: false,
          },
          hasWill: false,
          isWillUptoDate: false,
          isPowerOfAttorneyGranted: false,
          nationalClientIdentifier: '',
        },
        corporate: {
          name: '',
          type: '',
          businessType: '',
          companyRegistrationNumber: '',
          establishedOrIncorporatedOn: '',
          isVatRegistered: false,
          vatRegistrationNumber: '',
          legalEntity: {
            identifier: '',
            expiresOn: '',
          },
          businessRegistrationNumber: '',
        },
        trust: {
          name: '',
          type: '',
          establishedOrIncorporatedOn: '',
          registrationNumber: '',
          registeredOn: '',
          legalEntity: {
            identifier: '',
            expiresOn: '',
          },
          instrument: '',
          businessRegistrationNumber: '',
          natureOfTrust: '',
          vatRegistrationNumber: '',
          residenceCountry: {
            id: 0
          },
          establishmentCountry: {
            id: 0
          },
        },
        isHeadOfFamilyGroup: false,
        servicingAdministrator: {
          id: 0,
        },
        paraplanner: {
          id: 0
        },
        tags: [''],
        taxReferenceNumber: '',
        user: {
          id: 0
        },
        serviceStatus: {
          name: '',
          startedOn: '',
        },
        clientSegment: {
          name: '',
          startedOn: '',
        },
        group: {
          id: 0
        },
        household: {
          name: ''
        }
      },
    };
  },

  methods: {
    getClientData() {
      axios.get(`/io/client-data/${this.client_id}`).then((res) => {
        this.form = res.data.form;
        this.uploading = false;
        console.log(res.data);
      }).catch((error) => {
        console.log('error', error)
      })
    },
    sendNewData() {
      axios.post(`/io/client-data/${this.client_id}/update`, this.form)
          .then((res) => {
            console.log(res.data);
            this.$emit('data-updated', res.data);
          })
          .catch((error) => {
            console.log('error', error)
          })
    },

  },
  created() {
    this.getClientData();
  }
};
</script>

<style scoped>
.missing-data-icon {
  position: absolute; right: -10px; top: 8px;
}
</style>
